export default "__VITE_ASSET__a8ec3f47__"